import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import memoize from 'memoize-one';
import { BlockTabs, Button, ButtonGroup, Panel, TYPES } from 'sarsaparilla';
import LoadingWrapper from '../../../../ui-lottery/src/components/LoadingWrapper';
import { STATE_READY, STATE_UNLOADED } from '../../../../ui-lottery/src/utils/async_utils';
import { fetchOrganizations } from '../../actions/organization';
import AddressesTab from '../../components/StewardAssetEdit/AddressesTab';
import ImagesTab from '../../components/StewardAssetEdit/ImagesTab';
import LinkTab from '../../components/StewardAssetEdit/LinkTab';
import { CurrentUserProps } from '../../props/currentUser';
import { OrganizationProps } from '../../props/organization';
import { getCurrentUser } from '../../reducers/currentUser';
import ActivitiesTab from '../../components/StewardAssetEdit/ActivitiesTab';
import AssetTab from '../../components/StewardAssetEdit/AssetTab';
import { getState } from '../../reducers';
import { getOrganization } from '../../reducers/organizations';
import { flattenOrg, orgsToOptions } from '../../utils/organization';
import { assetTypeDetails } from '../../utils/asset';
import { clearChanges, removeRefs, saveChanges } from '../../actions/changes';

import styles from '../StewardAssetEditPage/StewardAssetEditPage.scss';
import { orgs } from "../../constants/organizations";

const propTypes = {
    match: TYPES.MATCH,
    history: TYPES.HISTORY,
    currentUser: CurrentUserProps,
    asset: PropTypes.shape({}),
    organization: OrganizationProps,
    states: PropTypes.objectOf(PropTypes.number),
    changes: PropTypes.arrayOf(PropTypes.object),
    fetchOrganizations: PropTypes.func.isRequired,
    clearChanges: PropTypes.func.isRequired,
    saveChanges: PropTypes.func.isRequired,
    removeRefs: PropTypes.func.isRequired
};

export class StewardAssetNewPage extends React.Component {
    constructor(props) {
        super(props);

        this.doCancel = this.doCancel.bind(this);
        this.doSave = this.doSave.bind(this);
    }

    componentDidMount() {
        if (this.props.states.organizations === STATE_UNLOADED) {
            this.props.fetchOrganizations();
        }
    }

    componentWillUnmount() {
        this.props.removeRefs();
    }

    getOrgOptions = memoize((organizationsState, currentUserState, organization) => {
        if (organizationsState === STATE_READY && currentUserState === STATE_READY) {
            if (organization) {
                return orgsToOptions(flattenOrg(organization));
            }
        }

        return [];
    });

    doCancel() {
        const { assetType } = this.props.match.params;
        this.props.history.push(`/data-steward/${assetType}/search`);
    }

    doSave() {
        const { changes, match: { params: { assetType } } } = this.props;
        // set them to default org ID FEDERAL if they did not select an organization
        changes.map(change => {
            const modifiedChange = { ...change };
            modifiedChange.changes.orgId = modifiedChange.changes.orgId || orgs.FEDERAL;
            return modifiedChange;
        });

        this.props.saveChanges(changes, '')
            .then((assetId) => {
                this.props.history.push(`/data-steward/${assetType}/${assetId}/display`)
            })
            .catch(() => {
            }); // TODO Handle Error
    }

    render() {
        const {
            match: { params: { assetType } },
            states: { organizations: organizationsState, currentUser: currentUserState },
            organization
        } = this.props;
        const orgOptions = this.getOrgOptions(organizationsState, currentUserState, organization);
        const details = assetTypeDetails(assetType);
        const loading = this.props.states.organizations !== STATE_READY || !orgOptions;

        const asset = {
            activities: [],
            addresses: [],
            links: [],
            media: []
        };

        return (
            <div className={styles['steward-asset-edit']}>
                <BlockTabs indentTabs>
                    <Panel label={details.name} className={styles['asset-tab']}>
                        <LoadingWrapper loading={loading} size="large">
                            <AssetTab
                                assetDetails={details}
                                value={asset}
                                orgOptions={orgOptions} />
                        </LoadingWrapper>
                    </Panel>
                    <Panel label="Activities" className={styles['activities-tab']}>
                        <LoadingWrapper loading={loading} size="large">
                            <ActivitiesTab
                                activityType={details.activities}
                                value={asset} />
                        </LoadingWrapper>
                    </Panel>
                    <Panel label="Addresses" className={styles['addresses-tab']}>
                        <LoadingWrapper loading={loading} size="large">
                            <AddressesTab
                                addressType={details.addresses}
                                value={asset} />
                        </LoadingWrapper>
                    </Panel>
                    <Panel label="Links" className={styles['links-tab']}>
                        <LoadingWrapper loading={loading} size="large">
                            <LinkTab
                                linkType={details.links}
                                value={asset} />
                        </LoadingWrapper>
                    </Panel>
                    <Panel label="Images" className={styles['images-tab']}>
                        <LoadingWrapper loading={loading} size="large">
                            <ImagesTab
                                mediaType={details.media}
                                value={asset} />
                        </LoadingWrapper>
                    </Panel>
                    <Panel label="Events" className={styles['events-tab']}>
                        <p>Available after the record has been saved.</p>
                    </Panel>
                    <Panel label="Site Maps" className={styles['siteMaps-tab']}>
                        <p>Available after the record has been saved.</p>
                    </Panel>
                </BlockTabs>
                <div className={styles['form-footer']}>
                    <ButtonGroup>
                        <Button appearance="tertiary" onClick={this.doCancel}>Cancel</Button>
                        <Button onClick={this.doSave}>Save Changes</Button>
                    </ButtonGroup>
                </div>
            </div>
        );
    }
}

StewardAssetNewPage.propTypes = propTypes;

const mapStateToProps = (state) => ({
    currentUser: getCurrentUser(state),
    asset: {},
    organization: getOrganization(state, getCurrentUser(state).apiKey.orgId),
    states: getState(state, 'organizations', 'currentUser'),
    changes: state.portal.changes
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchOrganizations,
    saveChanges,
    clearChanges,
    removeRefs
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StewardAssetNewPage);
